"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _dicts = require("@package/dicts");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Form(_ref) {
  var isEdit = _ref.isEdit,
      handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine;

  try {
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog_form']
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['code']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0418\u043C\u044F \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u044F",
      name: "name",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "Email",
      name: "email",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      type: 'phone',
      label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D:",
      name: "phone",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['form__roles']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['form__roles-title']
    }, "\u0420\u043E\u043B\u0438"), /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      options: _dicts.ROLES,
      type: 'multiple',
      name: "roles",
      disabled: inProcess
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['form__info']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430. \u0420\u043E\u043B\u0435\u0439 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E")))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "options.submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, isEdit ? 'Обновить' : 'Добавить сотрудника')));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Form;
exports["default"] = _default;